import { Card, Table } from "antd";

// Bảng dữ liệu thô của tab "Nguồn ngoài". Tách khỏi app-growth-external-tab.js để
// file đó không vượt mốc 200 dòng.
//
// ⚠️ Ô "—" nghĩa là NGUỒN KHÔNG CUNG CẤP chỉ số đó (cột NULL trong DB), KHÁC với 0.
// Apple không có lượt gỡ; Play không có lượt hiển thị. Render 0 thay cho NULL là bịa
// dữ liệu — cả tầng DB lẫn connector đều cố ý giữ NULL, đừng phá ở đây.
//
// ⚠️ Cột "Ngày" là ngày THEO QUY CHIẾU CỦA NGUỒN (Apple UTC · Play giờ Thái Bình
// Dương), không phải ngày VN. Tiêu đề cột ghi rõ để không ai đọc ngang hàng với tab
// Nội bộ.

const nf = new Intl.NumberFormat("vi-VN");

/** NULL → "—"; số → có dấu phân cách nghìn. */
const num = (v) => (v == null ? "—" : nf.format(v));

const COLUMNS = [
    { title: "Nguồn", dataIndex: "source", width: 110 },
    { title: "Ngày (theo nguồn)", dataIndex: "stat_date", width: 140 },
    { title: "Tải lần đầu", dataIndex: "downloads_first_time", render: num },
    { title: "Tải lại", dataIndex: "redownloads", render: num },
    { title: "Gỡ", dataIndex: "uninstalls", render: num },
    { title: "Hiển thị", dataIndex: "impressions", render: num },
    { title: "Xem trang", dataIndex: "product_page_views", render: num },
    { title: "Máy còn giữ", dataIndex: "active_devices", render: num },
];

function ExternalRawTable({ rows = [], loading }) {
    return (
        <Card size="small" title="Dữ liệu thô" loading={loading}>
            <Table
                size="small"
                rowKey={(r) => `${r.source}-${r.stat_date}`}
                dataSource={rows}
                pagination={{ pageSize: 20, size: "small" }}
                scroll={{ x: true }}
                columns={COLUMNS}
            />
            <p className="text-xs text-gray-500 mt-2 mb-0">
                Ô “—” nghĩa là <b>nguồn đó không cung cấp chỉ số này</b> (vd Apple không có lượt gỡ,
                Play không có lượt hiển thị), <b>không phải bằng 0</b>.
            </p>
        </Card>
    );
}

export default ExternalRawTable;
